import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbsenceEmployeeStatusEnum } from '@qaroni-app/absences/types/absence-employee-status.enum';

@Component({
  selector: 'qaroni-absence-employee-status-chip',
  templateUrl: './absence-employee-status-chip.component.html',
  styleUrl: './absence-employee-status-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AbsenceEmployeeStatusChipComponent {
  readonly status = input<AbsenceEmployeeStatusEnum | null>(null);

  get bgClassColorName(): string {
    switch (this.status()) {
      case AbsenceEmployeeStatusEnum.APPROVED:
        return 'qaroni-bg-primary50';
      case AbsenceEmployeeStatusEnum.REJECTED:
        return 'qaroni-bg-danger-light';
      default:
        return 'qaroni-bg-success';
    }
  }
}
